import { FluxType } from 'flux/buildFlux';
import React, { Component, ComponentType } from 'react';

import { flux } from '../../singletons';

export interface AddFluxHOCProps {
  flux: FluxType;
}

export const addFlux = function <P>(
  ComposedComponent: ComponentType<P & AddFluxHOCProps>,
) {
  return class AddFluxInternal extends Component<Exclude<P, AddFluxHOCProps>> {
    static displayName = 'AddFlux';

    render() {
      return <ComposedComponent {...this.props} flux={flux} />;
    }
  };
};
